import { type RefObject, useEffect, useState } from "react";
import { SECTION_THREE_MIN_PINNED_DWELL_UNITS } from "../../scroll/landing-scroll-timeline";
import { SECTION_THREE_RUNWAY_HEIGHT_UNITS } from "../three/use-section-three-scroll";

/**
 * S4 pulls up over the pinned S3 world by exactly its own measured height. The
 * runway is sized to S4's height + one viewport + the minimum pinned dwell (see
 * use-section-three-scroll), so S4's edge meets the fold a fixed beat after the
 * pin on any viewport height, and the cover ends exactly when the section ends —
 * no S3 runway is left scrolling past the footer. The S3 handoff keys off S4's
 * measured position, so the scrim tracks this value. Measured via
 * ResizeObserver because remote logos/portrait can grow the section after mount.
 */
export function useSectionFourOverlapUnits(sectionRef: RefObject<HTMLElement | null>) {
	const [overlapUnits, setOverlapUnits] = useState<number>(
		() => SECTION_THREE_RUNWAY_HEIGHT_UNITS - 1 - SECTION_THREE_MIN_PINNED_DWELL_UNITS,
	);

	useEffect(() => {
		const section = sectionRef.current;
		if (!section) return;
		const measure = () => {
			const viewportHeight = Math.max(window.innerHeight, 1);
			setOverlapUnits(section.offsetHeight / viewportHeight);
		};
		measure();
		const observer = new ResizeObserver(measure);
		observer.observe(section);
		window.addEventListener("resize", measure);
		return () => {
			observer.disconnect();
			window.removeEventListener("resize", measure);
		};
	}, [sectionRef]);

	return overlapUnits;
}
